<template>
  <div class="main-wraps">
    <div class="bg-part wrap-wraps">
      <p class="flex tc ptb10 bdb ft14">
        <span class="flex1">{{$t('td.num')}}</span>
        <span class="flex1">{{$t('coin.profit')}}</span>
        <span class="flex1">{{$t('zdy.scsj')}}</span>
        <span class="flex1">{{$t('coin.endtine')}}</span>
        <span class="flex1">{{$t('fat.status')}}</span>
      </p>
      <ul>
        <li class="flex tc ptb10 bdb" v-for="item in log_list">
          <span class="flex1">{{item.amount}}</span>
          <span class="flex1">{{item.amount * item.total_rate/100}}</span>
          <span class="flex1">{{item.created_at}}</span>
          <span class="flex1">{{item.end_at}}</span>
          <span v-if="item.status==1" :class="['flex1',{'redColor':item.status==1}]">{{$t('zdy.zyz')}}</span>
          <span v-if="item.status==2" :class="['flex1',{'redColor':item.status==2}]">{{$t('zdy.zwc')}}</span>
          <span v-if="item.status==3" :class="['flex1',{'redColor':item.status==3}]">{{$t('zdy.zqx')}}</span>
        </li>
      </ul>
       <p class="tc more ptb10 ft12" @click="getMore">{{more}}</p>
    </div>
  </div>
</template>
<script>
export default {
    name:'manageList',
    data(){
        return {
            more:'加载更多',
            page:1,
            limit:20,
            log_list:[]
        }
    },
    filters: {
    toFixeds: function(value) {
      value = Number(value);
      return value.toFixed(2);
    }
  },
    created(){

    },
    mounted(){
        this.init();
    },
    methods:{
        init(){
          let that=this;
            var i = layer.load();
            this.$http({
                url: '/api/currency/deposit/list?limit='+that.limit+"&page="+that.page,
                method:'get',
                // data:{limit:that.limit,page:that.page},  
                headers: {'Authorization':  localStorage.getItem('token')},    
            }).then(res=>{
                layer.close(i);
                if(res.data.type=="ok"){
                    that.log_list = that.log_list.concat(res.data.message.list);
                    if(res.data.message.list.length == 0){
                        that.more = that.$t('td.nodata')
                    }
                    if(res.data.message.list.length<that.limit){
                        that.more = that.$t('td.nomore')
                    }else if(res.data.message.list.length==that.limit){
                        that.more = that.$t('td.more')
                    }
                }else{
                    layer.msg(res.data.message)
                }
            }).catch(error=>{
                // console.log(error)
            })
        },
        getMore(){
             this.more = '加载中...'
            this.page+=1;
            this.init();
        }
        
    }
}
</script>
<style scoped>
  .main-wraps{
    padding: 30px 50px;
  }
    .wrap-wraps{
      max-width: 1000px;
      margin: 0 auto;
      min-height: 700px;
    }
    .ptb10{
      padding: 10px 0;
    }
</style>



// WEBPACK FOOTER //
// src/view/manageList.vue